import React, { useState } from 'react';

const AbaSMS = () => {
  const [mensagem, setMensagem] = useState('');
  const [numero, setNumero] = useState('');

  const handleSend = (e) => {
    e.preventDefault();
    alert(`SMS enviado para ${numero}`);
  };

  return (
    <div className="form-section">
      <h2 className="form-title">Envio de mensagem SMS</h2>

      <form onSubmit={handleSend} className="form-fields">
        <div className="input-group">
          <input
            type="tel"
            placeholder="Número com DDD"
            value={numero}
            onChange={(e) => setNumero(e.target.value)}
            className="form-input"
          />
          <textarea
            placeholder="Digite sua mensagem"
            value={mensagem}
            onChange={(e) => setMensagem(e.target.value)}
            className="form-input"
            rows={4}
          />
        </div>
        <button type="submit" className="submit-button">Enviar SMS</button>
      </form>
    </div>
  );
};

export default AbaSMS;
